module.exports = __webpack_public_path__ + "684865896bfcb619459a8d6671e947ea.svg";